<template>
  <b-overlay
    id="overlay-background"
    :show="loader"
    variant="dark"
    opacity="0.85"
    blur="2px"
    rounded="sm"
    spinner-variant="primary"
    spinner-medium
  >
    <b-row>
      <b-col
        md="5"
        lg="5"
        offset-lg="3"
        class="fields-container"
      >
        <b-card
          no-body
          class="card-payment"
        >
          <b-card-body>
            <b-form>
              <b-row
                v-for="option in DocumentSettingOptions"
                :key="option.key"
                class="align-items-center mb-1 border-bottom pb-1"
              >
                <b-col
                  sm="8"
                  class="pr-2 font-weight-bold"
                >
                  {{ $t(option.labelKey) }}
                </b-col>
                <b-col
                  sm="4"
                  class="pl-2 text-sm-right"
                >
                  <b-form-checkbox
                    v-model="option.value"
                    switch
                    inline
                    :true-value="1"
                    :false-value="0"
                  />
                </b-col>
              </b-row>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                block
                variant="primary"
                class="mt-2"
                @click="postDocumentSettingValues"
              >
                {{ $t('SAVE') }}
              </b-button>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import {
  BOverlay,
  BCard,
  // BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BForm,
  BFormCheckbox,
  BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import axios from '@axios'

export default {
  components: {
    BOverlay,
    BCard,
    // BCardHeader,
    BCardBody,
    BRow,
    BCol,
    BForm,
    BFormCheckbox,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    settings: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      loader: false,
      DocumentSettingOptions: [],
      documentOptions: [
        { key: 'case_doc_action', labelKey: 'DEBTIA_ACTION' },
        { key: 'case_doc_category', labelKey: 'DEBTIA_CATEGORY' },
        { key: 'case_doc_title', labelKey: 'DEBTIA_TITLE' },
        { key: 'case_doc_file_link', labelKey: 'DEBTIA_FILE_LINK' },
        { key: 'case_doc_payment_amount', labelKey: 'DEBTIA_PAYMENT_AMOUNT' },
        { key: 'case_doc_vat_amount', labelKey: 'DEBTIA_VAT_AMOUNT' },
        { key: 'case_doc_uploaded_by', labelKey: 'DEBTIA_UPLOADED_BY' },
        { key: 'case_doc_paid_amount', labelKey: 'DEBTIA_PAID_AMOUNT' },
        { key: 'case_doc_interest_rate_percentage', labelKey: 'DEBTIA_INTEREST_RATE' },
        { key: 'case_doc_document_due_date', labelKey: 'DEBTIA_DOCUMENT_DUE_DATE' },
        { key: 'case_doc_document_send_date', labelKey: 'DEBTIA_DOCUMENT_SEND_DATE' },
        { key: 'case_doc_uploaded_at', labelKey: 'DEBTIA_UPLOAD_DATE' },
      ],
    }
  },
  watch: {
    settings: {
      immediate: true,
      handler() {
        this.mapValues()
      },
    },
  },
  methods: {
    mapValues() {
      this.DocumentSettingOptions = this.documentOptions.map(option => {
        const setting = this.settings.find(
          item => item.key === option.key,
        )
        return {
          key: option.key,
          labelKey: option.labelKey,
          value: setting ? Number(setting.value) === 1 : true,
        }
      })
    },
    postDocumentSettingValues() {
      this.loader = true
      const payload = this.DocumentSettingOptions.map(option => ({
        key: option.key,
        value: option.value,
      }))
      axios.post('user-settings/save', payload)
        .then(response => {
          if (response.data.status) {
            this.loader = false
            this.makeSuccessToast()
          }
        })
        .catch(error => {
          this.makeFailureToast(error)
        })
    },
    makeSuccessToast() {
      this.$bvToast.toast('Settings have been successfully updated', {
        title: 'Success',
        variant: 'success',
        solid: false,
      })
    },
    makeFailureToast(error) {
      this.loader = false
      this.$bvToast.toast(
        error?.response?.data?.message || 'Something went wrong',
        {
          title: 'Failed',
          variant: 'danger',
          solid: false,
        },
      )
    },
  },
}
</script>
